<template>
  <div>
    <el-steps :active="active" align-center >
      <el-step :title="$t(`lang.${step.title}`)" v-for="(step, index) in stepList" :key="index +'_step'" @click.native="handleChangeStep(index)">
        <div slot="icon" style="background: #ffffff">
          <div :class="{'icon-row': index <= active }">
            <svg-icon  :icon-class="step.icon" className="step-icon"></svg-icon>
          </div>
        </div>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: "RecipeStep",
  model: {
    prop: 'active',
    event: 'change'
  },
  props: {
    stepList: {
      type: Array,
      default() {
        return [];
      }
    },
    active: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleChangeStep(index) {
      if(index == this.active || index == 8) return;
      this.$emit('change', index);
    },


  }
}
</script>

<style scoped>
.step-icon {
  width: 40px;
  height: 40px;
  padding: 14px;
  border-radius: 50%;
  border: 1px solid #dddddd;
}


.icon-row {
  border-radius: 50%;
  background: #368ade;
  background: rgba(49, 135, 221, .2);
  border: 1px solid #368ade;
}


</style>
